export function formatTime(timeString, locale = 'fr-FR') {
    const time = new Date(timeString);
    let hours = time.getHours();
    let minutes = time.getMinutes();
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutes}`;
}
export function isTimeInRange(timeString, timeRange) {
    const time = new Date(`1970-01-01T${timeString}:00`);
    const from = timeRange.from;
    const to = timeRange.to;
    const startTime = new Date(`1970-01-01T${from}:00`);
    const endTime = new Date(`1970-01-01T${to}:00`);

    return (
        (time > startTime && time < endTime) ||
        time.getTime() === startTime.getTime() ||
        time.getTime() === endTime.getTime()
    );
}
export function convertDuration(duration, locale) {
    const regex = /PT(\d+)H(\d+)M/;
    const regex2 = /PT(\d+)H/;
    const match = regex.exec(duration);
    const match2 = regex2.exec(duration);
    if (match) {
        const hours = match[1].padStart(2, '0');
        const minutes = match[2].padStart(2, '0');
        if (locale === 'en') {
            return hours + 'h ' + minutes + 'm';
        }
        return hours + 'س ' + minutes + 'د';
    } else if (match2) {
        const hours = match2[1].padStart(2, '0');
        const minutes = '00';
        if (locale === 'en') {
            return hours + 'h ' + minutes + 'm';
        }
        return hours + 'س ' + minutes + 'د';
    }
    return '';
}
export function getStopDuration(locale, date, date1) {
    const dateTime1 = new Date(date);
    const dateTime2 = new Date(date1);
    const difference = Math.abs(dateTime2 - dateTime1);
    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    if (locale === 'en') {
        return `${hours} h ${minutes} m`;
    }
    return `${hours} س ${minutes} د`;
}
export function formatDuration(minutes, type, language = "en") {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (type == 0) {
        if (language === "ar") {
            return `${hours} ساعة ${remainingMinutes.toString().padStart(2, "0")} دقيقة`;
        } else {
            return `${hours}hrs ${remainingMinutes.toString().padStart(2, "0")}mins`;
        }
    } else {
        if (language === "ar") {
            return `${hours} س ${remainingMinutes.toString().padStart(2, "0")} د`;
        } else {
            return `${hours}h ${remainingMinutes.toString().padStart(2, "0")}m`;
        }
    }
}
export function parseDurationToMinutes(duration) {
    const hoursMatch = duration.match(/(\d+)H/);
    const minutesMatch = duration.match(/(\d+)M/);
    const hours = hoursMatch ? parseInt(hoursMatch[1]) : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1]) : 0;
    return hours * 60 + minutes;
}